import React from 'react'
import { Tooltip } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'
import ResultButton from './ResultButton'

const GoToUnifiedDashboard = ({ analysisWrapperId }) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/libra/unified/${analysisWrapperId}`)
  }

  return (
    <Tooltip title="Multi-Omic View (MOV)" arrow>
      <ResultButton onClick={handleClick}>MOV</ResultButton>
    </Tooltip>
  )
}

export default GoToUnifiedDashboard
